import { FieldTemplate, LayoutItem } from 'api/models';
import { Comment } from 'api/models/Comment';
import { RecoilState, atom, selector, selectorFamily } from 'recoil';

export const formsFieldTemplates: RecoilState<FieldTemplate[]> = atom<
  FieldTemplate[]
>({
  key: 'formsFieldTemplates',
  default: [],
});

export const formsFieldTemplatesMap = selector({
  key: 'formsFieldTemplatesMap',
  get: ({ get }) => {
    const fieldMap = new Map<string, FieldTemplate>();
    const fieldTemplates = get(formsFieldTemplates);
    fieldTemplates.forEach(t => fieldMap.set(t.id, t));
    return fieldMap;
  },
});

export const lastTimeFormWasSaved = atom<string | undefined>({
  key: 'lastTimeFormWasSaved',
  default: undefined,
});

export const commentsAtom: RecoilState<Comment[]> = atom<Comment[]>({
  key: 'comments',
  default: [],
});

export const commentsByFieldTemplateId = selectorFamily<Comment[], string>({
  key: 'commentsByFieldId',
  get:
    fieldTemplateId =>
    ({ get }) => {
      return get(commentsAtom).filter(
        c => c.fieldTemplateId === fieldTemplateId,
      );
    },
});

export const formLayoutItemsState: RecoilState<LayoutItem[]> = atom<
  LayoutItem[]
>({
  key: 'formLayoutItems',
  default: [],
});

export const isCalculationsLoading = atom<boolean>({
  key: 'isCalculationsLoading',
  default: false,
});
